export default __webpack_public_path__ + "static/media/J720_CoC.e5fb978a.pdf";